module.exports = __webpack_public_path__ + "static/media/predestinado_b.c75de45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/predestinado_b.png
// module id = 1169
// module chunks = 0